import EditUser from 'modules/Admin/settings/EditUser'

function SettingsEditUserPage() {
  return (
    <div data-testid="editUserSettingsPage">
      <EditUser />
    </div>
  )
}

export default SettingsEditUserPage
